/**
 * services/apiClient.js — Axios instance pre-configured for the AI Pulse API.
 *
 * - Base URL: /api (proxied to API Gateway in dev via vite.config.js)
 * - Request interceptor: attaches Bearer token from sessionStorage
 * - Response interceptor: redirects to /login on 401
 */

import axios from 'axios'

const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Attach Bearer token on every request
apiClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('aipulse_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Redirect to login on 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('aipulse_token')
      sessionStorage.removeItem('aipulse_user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default apiClient
